import { SVGProps } from 'react'

export const VideoRecorderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 3.46569C11 3.16278 11 3.01132 10.9401 2.94119C10.8881 2.88034 10.8102 2.84805 10.7304 2.85432C10.6384 2.86156 10.5313 2.96865 10.3172 3.18284L8.5 5L10.3172 6.81716C10.5313 7.03135 10.6384 7.13844 10.7304 7.14568C10.8102 7.15195 10.8881 7.11966 10.9401 7.05881C11 6.98868 11 6.83722 11 6.53431V3.46569Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 3.9C1 3.05992 1 2.63988 1.16349 2.31901C1.3073 2.03677 1.53677 1.8073 1.81901 1.66349C2.13988 1.5 2.55992 1.5 3.4 1.5H6.1C6.94008 1.5 7.36012 1.5 7.68099 1.66349C7.96323 1.8073 8.1927 2.03677 8.33651 2.31901C8.5 2.63988 8.5 3.05992 8.5 3.9V6.1C8.5 6.94008 8.5 7.36012 8.33651 7.68099C8.1927 7.96323 7.96323 8.1927 7.68099 8.33651C7.36012 8.5 6.94008 8.5 6.1 8.5H3.4C2.55992 8.5 2.13988 8.5 1.81901 8.33651C1.53677 8.1927 1.3073 7.96323 1.16349 7.68099C1 7.36012 1 6.94008 1 6.1V3.9Z"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
